export default __webpack_public_path__ + "assets/staff-management.62e701a4.svg";